if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})


		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});


					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});


					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

					let cartActions = document.querySelector(".cart-actions.buttons-holder");
    let cartItemCount = cartItems.querySelector('[data-cart-count]').textContent; // Dynamically get cart count from Liquid

    let popup = document.getElementById("box-selection-popup");
    let checkoutButton = document.querySelector("button[name='checkout']");
    let message = document.querySelector(".select-msg");

    if (cartItemCount >= 2 && cartActions && popup) {
        let button = document.createElement("button");
        button.id = "open-popup";
        button.className = "button button--outline";
        button.style.textAlign = "center";
        button.textContent = "Select Packaging";
        checkoutButton.setAttribute("data-active", "false");
        checkoutButton.style.opacity = "0.5";   
                cartActions.prepend(button);
                 document.getElementById("open-popup").addEventListener("click", function() {
            document.getElementById("box-selection-popup").style.display = "block";
        });
              
        
        document.querySelectorAll(".close-popup").forEach(button => {
            button.addEventListener("click", function() {
                document.getElementById("box-selection-popup").style.display = "none";
            });
        });
        
        // Close popup when clicking outside the content
        window.addEventListener("click", function(event) {
            if (event.target === popup) {
                popup.style.display = "none";
            }
        });
              checkoutButton.addEventListener("click", function (event) {
            if (checkoutButton.getAttribute("data-active") === "false") {
                event.preventDefault();
                message.style.display = "block"; // Show message
                setTimeout(() => {
                    message.style.display = "none"; // Hide message after 3 seconds
                }, 3000);
            }
        });
          let cartNote = document.getElementById("cartSpecialInstructions");
        let checkoutButton = document.querySelector("button[name='checkout']");
    let message = document.querySelector(".select-msg");

    let currentIndex = 0;
    let images = [];

    document.querySelectorAll("input[name='box-selection']").forEach(radio => {
        radio.addEventListener("change", function() {
            cartNote.value = "Selected Packaging: " + this.value;
            updateCartNote();
            checkoutButton.setAttribute("data-active", "true");
                checkoutButton.style.opacity = "1";
                message.style.display = "none";
        });
    });

    function updateCartNote() {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note:cartNote.value })
        }).then(response => response.json()).then(data => {
            console.log("Cart note updated:", data);
        });
    }
    }

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});

		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})
	}

}
    let cartN = document.getElementById("cartSpecialInstructions");
        let checkoutB = document.querySelector("button[name='checkout']");
    let messages = document.querySelector(".select-msg");

    let currentIndex = 0;
    let images = [];

    document.querySelectorAll("input[name='box-selection']").forEach(radio => {
        radio.addEventListener("change", function() {
            cartN.value = "Selected Packaging: " + this.value;
            updateCartNote();
            checkoutB.setAttribute("data-active", "true");
                checkoutB.style.opacity = "1";
                messages.style.display = "none";
        });
    });

    function updateCartNote() {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note:cartN.value })
        }).then(response => response.json()).then(data => {
            console.log("Cart note updated:", data);
        });
    }